//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('furnitureFabricsColor', {
//        templateUrl: 'views/components/views/furnitureFabricsColor/furnitureFabricsColor.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'furnitureFabricsColorService', function ($stateParams, stateService, modalService, translateService, furnitureFabricsColorService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let furnitureFabricsId = $stateParams.furniturefabrics_id;
//            let furnitureFabricsColorId = $stateParams.furniturefabricscolor_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListLights: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await furnitureFabricsColorService.getEdit({
//                    furniturefabrics_id: furnitureFabricsId,
//                    furniturefabricscolor_id: furnitureFabricsColorId
//                }))[0];
//            }

//            async function loadFurnitureFabricsLights() {
//                vm.model.selectListLights = await furnitureFabricsColorService.listFurnitureFabricsLights();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                furnitureFabricsColorService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadFurnitureFabricsLights();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
